//! 创建ResizeObserver监听网站响应式变化
export default (el?: HTMLElement, callBack?: (size: number) => void): ResizeObserver | undefined => {
    if (!el) return;
    if (process.client) {
        //* 数据初始化
        const config: { size: number; timeout?: NodeJS.Timeout } = { size: 0 };
        //* 注册observer
        const observer = new ResizeObserver((nodes) => {
            //* 移除计时器
            config.timeout && clearTimeout(config.timeout);
            config.timeout = setTimeout(() => {
                //* 触发计时器后清除计时器缓存
                config.timeout = undefined;
                //* 仅宽度发生变化时触发
                const node = nodes?.[0];
                if (node && config.size != node.target.clientWidth) {
                    config.size = node.target.clientWidth;
                    if (callBack) {
                        callBack(config.size);
                    }
                }
            }, 20);
        });

        //* 监听dom
        observer.observe(el);

        //* 销毁函数二次封装
        return {
            observe: observer.observe,
            unobserve: observer.unobserve,
            disconnect: () => {
                //* 释放observer
                observer.disconnect();
                //* 释放可能存在的定时器
                if (config.timeout) {
                    clearTimeout(config.timeout);
                }
            },
        };
    }
};
